export async function callCohere(input: string, context: any, apiKey: string, signal?: AbortSignal): Promise<string> {
  try {
    const res = await fetch('https://api.cohere.ai/v1/chat', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${apiKey}`,
        'Content-Type': 'application/json'
      },
      signal,
      body: JSON.stringify({
        model: context.modelOverride || 'command-r',
        message: input,
        preamble: `You are OS Bot, a real estate CRM assistant. Personality: ${context.personality || 'professional'}. Recent context: ${JSON.stringify(context.recentMessages || [])}`,
        temperature: 0.2
      })
    });
    
    if (!res.ok) {
      const errorData = await res.json();
      throw new Error(errorData.message || `Cohere API error: ${res.status}`);
    }

    const data = await res.json();
    return data.text || '';
  } catch (error: any) {
    console.error('[Cohere Provider] Error:', error);
    throw error;
  }
}
